export const PARAGRAPHS = [
  { title: 'CONCURSO', url: '/bases-del-concurso' },
  { title: 'CONCURSO_EDICION', url: '/bases-del-concurso' },
  { title: 'CONCURSO_ORGANIZA' },
  { title: 'CONCURSO_PARTICIPAR' },
  { title: 'CONCURSO_PATROCINA' },
];

export const FOOTER_DATA = [
  { label: 'Aviso legal', url: '/aviso-legal' },
  { label: 'Impressum', url: '/impressum' },
  {
    label: 'HessenWald Schule',
    url: 'https://www.hessenwaldschule.de/',
    external: true,
  },
  {
    label: 'HMKB Hessen Schülerwettbewerbe',
    url: 'https://kultusministerium.hessen.de/programme-und-projekte/schuelerwettbewerbe',
    external: true,
  },
  {
    label: 'GER Gemeinsamen Europäischen Referenzrahmen',
    url: 'http://www.europaeischer-referenzrahmen.de/spanisch-sprachzertifikate.php',
    external: true,
  },
  { label: 'Admin', url: '/admin' },
];
